import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { RoleModalComponent } from '../role-modal-add/role-modal-add.component';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { RoleDetailsRest } from '../role-details/role-details.rest';
@Component({
    selector: 'app-roles-list',
    templateUrl: './roles-list.component.html',
    styleUrls: ['./roles-list.component.scss']
  })
  export class RolesListComponent implements OnInit, HasPermissions, AfterViewInit {
    permissions: Permissions;

    private path: string;
    public viewEnable = true;

    private headers = [
      { displayName: 'Rola', propertyName: 'roleName', propertyType: 'string' },
    ];

    @ViewChild(RoleModalComponent) modalRoleComponent: RoleModalComponent;
    @ViewChild(GridComponent) grid: GridComponent;

    constructor(
      private router: Router,
      private route: ActivatedRoute,
      private permissionService: PermissionsService,
      private spinnerService: SpinnerService,
      private rest: RoleDetailsRest
    ) {}

    setPermissions(claimType: string): void {
      this.permissions = this.permissionService.getUserPermissions(claimType);
    }

    ngOnInit() {
      this.spinnerService.show();
      this.path = 'api/roles/grid';
      this.setPermissions('Role');
    }

    ngAfterViewInit() {
      this.spinnerService.hide();
    }

    private getActionButtons() {
      return [];
    }

    private onRowEdit(row: any) {
      this.router.navigate(['role', row.roleName], { relativeTo: this.route });
    }

    private onRowAdd() {
      this.modalRoleComponent.openForAdd();
    }

    private onRowDelete(row: any) {
      sweetAlert('Czy usunąć rolę?', {
        buttons: {
          yes: {
            text: 'Tak',
            value: 'yes'
          },
          no: {
            text: 'Nie',
            value: 'no',
          }
        }
      })
      .then((value) => {
        switch (value) {
          case 'yes':
            this.rest.deleteRole(row.roleName).subscribe((result: string) => {
              if (result) {
                sweetAlert('Usunięto rolę ' + row.roleName);
                this.grid.refreshData();
              }
            });
            break;
        }
      });

    }

    private onSuccesModal(event: any) {
      sweetAlert('Dodano nową rolę');
      //console.log(event);
      this.grid.selectedItemId = event;
      this.grid.refreshData();
    }
  }
